import { useEffect, useState } from "react";
import { useCreateWaitlistMutation } from "@/graphql/mutations/createWaitlist.graphql.types";

type UseWaitlistProps = {
  clientId?: string;
  appointmentDate?: Date;
};

export type WaitlistActions = {
  isWaitlistDialogOpen: boolean;
  isWaitlistEntryCreated: boolean;
  isLoadingWaitlist: boolean;
  openWaitlistDialog: () => void;
  closeWaitlistDialog: () => void;
  handleWaitlistSuccess: () => void;
  addToWaitlist: ReturnType<typeof useCreateWaitlistMutation>[0];
};

export function useAddToWaitlistDialog({
  clientId,
  appointmentDate,
}: UseWaitlistProps): WaitlistActions {
  const [isWaitlistDialogOpen, setIsWaitlistDialogOpen] = useState(false);
  const [isWaitlistEntryCreated, setIsWaitlistEntryCreated] = useState(false);

  const [addToWaitlist, { loading: isLoadingWaitlist }] =
    useCreateWaitlistMutation();

  const date = appointmentDate?.getDate();

  // Reset "Add to waitlist" button when client or date changes
  useEffect(() => {
    setIsWaitlistEntryCreated(false);
  }, [clientId, date]);

  const openWaitlistDialog = () => {
    setIsWaitlistDialogOpen(true);
  };

  const closeWaitlistDialog = () => {
    setIsWaitlistDialogOpen(false);
  };

  const handleWaitlistSuccess = () => {
    setIsWaitlistEntryCreated(true);
    setIsWaitlistDialogOpen(false);
  };

  return {
    // State
    isWaitlistDialogOpen,
    isWaitlistEntryCreated,
    isLoadingWaitlist,

    // Actions
    openWaitlistDialog,
    closeWaitlistDialog,
    handleWaitlistSuccess,

    // Mutation
    addToWaitlist,
  };
}
